import { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useTenants } from '../hooks/useTenants';
import SystemsStore from 'Stores/SystemsStore';
import { NavItemConfig } from '../Siderbar.constant';
import { authStore } from 'Stores/AuthStore';
import SearchDropDown from './SearchDropdown';
import { apiRequest } from 'PhishingManager/service/apiHelper';
import ROUTES from 'Pages/User/service/index.constant';
import { APP_ROUTES } from 'Pages/App/App.constants';
import styles from '../Sidebar.module.scss';

type Props = {
    isSuperAdmin: boolean,
    systemsStore: SystemsStore
}

const NO_TENANT = { label: "sidebar.tenantSelector.noTenantOption", value: 0 };
const ALL_TENANTS = { label: "sidebar.tenantSelector.allTenantOption", value: -1 };

const TenantSelection = ({ isSuperAdmin, systemsStore } : Props) => {
    const { loading } = useTenants();
    const { selectedTenant, tenantList, rootTenant } = systemsStore;
	const { pathname } = useLocation();

    const handleItemClick = (item: NavItemConfig) => {
        const newTenant = { label: item.label, value: Number(item.path) };
        systemsStore.changeTenant(newTenant);
        systemsStore.changeRootTenant(newTenant);
    }

    const allowAllTenant: boolean = useMemo(() => {
        return isSuperAdmin ? pathname.includes(APP_ROUTES.ROLES) : false;
    }, [pathname, isSuperAdmin])

    const TENANTS: NavItemConfig[] = useMemo(() => {
        return tenantList.length ? [{ key: NO_TENANT.label, label: NO_TENANT.label, id: String(NO_TENANT.value), path: String(NO_TENANT.value) }, ...(allowAllTenant ? [{ key: ALL_TENANTS.label, label: ALL_TENANTS.label, id: String(ALL_TENANTS.value), path: String(ALL_TENANTS.value) }] : []), ...tenantList.map(tenant => ({
            id: String(tenant.value),
            key: tenant.label,
            label: tenant.label,
            path: String(tenant.value)
        }))] : [];
    }, [tenantList, allowAllTenant]);

    useEffect(() => {
        if (!isSuperAdmin && !selectedTenant.value) systemsStore.changeTenant(tenantList?.[0] ?? authStore?.currentUser?.groups?.map(el => {return {label: el.name, value: el.id}})[0]);

        if(isSuperAdmin && !allowAllTenant && selectedTenant.value === ALL_TENANTS.value) systemsStore.changeTenant(NO_TENANT);
    }, [tenantList, isSuperAdmin, selectedTenant, allowAllTenant]);

    useEffect(() => {
        if(!isSuperAdmin) {
            (async () => {
                try {
                    const response = await apiRequest(ROUTES.USER_ROOT_GROUP);
                    const tenant = response?.data || {};
                    systemsStore.changeRootTenant({ label: tenant?.name || "", value: tenant?.id || 0 });
                } catch (error) {
                    systemsStore.changeRootTenant(NO_TENANT);
                }
            })();
        }
    }, [isSuperAdmin])

    return !isSuperAdmin ? <span className={styles.logo__name}>{rootTenant.value != 0 ? rootTenant.label : ""}</span> : <div className='tenant_dropdown-container'>
        <SearchDropDown {...{ items: TENANTS, loading, handleItemClick, isTenantSelector: true, selectedItem: selectedTenant, disableDropDown: loading }} />
    </div>
}

export default observer(TenantSelection);